export enum Routes {
  LOGIN = "/app",
  SOLICITUDES = "/app/solicitudes",
  // Outside the enrolment routes: their context sends a validated migrating
  // doctor to the end of the validation.
  NUEVO_PIN_FIRMA = "/app/firma-electronica/nuevo-pin",
}
